module.exports = __webpack_public_path__ + "static/media/Ki.31f3692c.eot";